<div class="table-sort" (click) = "Edit(true)" *ngIf = "!edit">
    <div class="table-sort-img"><mat-icon>playlist_add_check</mat-icon></div>
    <div class="table-sort-tresc"><span id="zmien_kolumny" [translation]="TranslationEnum.TranslationForm">{{'zmien_kolumny'|translate}}</span></div>
</div>

<div class="edycja-listy" *ngIf = "edit">
<div class="example-container">
  <h2><span id="widoczne_kolumny" [translation]="TranslationEnum.TranslationForm">{{'widoczne_kolumny'|translate}}</span></h2>

  <div
    cdkDropList
    #todoList="cdkDropList"
    [cdkDropListData]="tableCol.DisplayedColumns"
    [cdkDropListConnectedTo]="[doneList]"
    class="example-list"
    (cdkDropListDropped)="drop($event)">
    <ng-container *ngFor="let item of tableCol.DisplayedColumns;">
        <div class="example-box" cdkDrag><span id="sort_{{item.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{'sort_'+item.toLowerCase()|translate}}</span>
          <div *ngIf = "czyUsun(item)" class="usun" (click) = "delete(item)"><mat-icon >delete_outline</mat-icon></div></div>
    </ng-container>
    
  </div>
</div>
<div class="example-container">
  <h2><span id="reszta_kolumn" [translation]="TranslationEnum.TranslationForm">{{'reszta_kolumn'|translate}}</span></h2>

  <div
    cdkDropList
    #doneList="cdkDropList"
    [cdkDropListData]="tableCol.OtherColumns"
    [cdkDropListConnectedTo]="[todoList]"
    class="example-list"
    (cdkDropListDropped)="dropBack($event)"> 
    <ng-container *ngFor="let item of tableCol.OtherColumns;">
        <div class="example-box" cdkDrag><span id="sort_{{item.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{'sort_'+item.toLowerCase()|translate}}</span></div>
    </ng-container>
  </div>
</div>
<div class="example-container" *ngIf = "false">
  <h2><span id="wszystkie_kolumny" [translation]="TranslationEnum.TranslationForm">{{'wszystkie_kolumny'|translate}}</span></h2>

  <div
    cdkDropList
    #doneList="cdkDropList"
    [cdkDropListData]="tableCol.AllColumns"
    [cdkDropListConnectedTo]="[todoList]"
    class="example-list"
    (cdkDropListDropped)="dropBack($event)"> 
    <ng-container *ngFor="let item of tableCol.AllColumns;">
        <div class="example-box" cdkDrag><span id="sort_{{item.toLowerCase()}}" [translation]="TranslationEnum.TranslationForm">{{'sort_'+item.toLowerCase()|translate}}</span></div>
    </ng-container>
  </div>
</div>



<div class="grid_buttons">
<button class="button" (click) = "przywroc()"><span id="przywroc_domyslne" [translation]="TranslationEnum.TranslationForm">{{'przywroc_domyslne'|translate}}</span></button>
<button class="button" (click) = "zapisz()"><span id="ok" [translation]="TranslationEnum.TranslationForm">{{'ok'|translate}}</span></button>
</div>

</div>
